import { api } from './axios';

/**
 * Duel Stats API — Расширенная статистика дуэлей
 * @see api_duel_stats_reference.md
 */

/**
 * Получить полную статистику профиля
 * @param {string} profileId - ID профиля
 * @returns {Promise<Object>} Статистика: рейтинг, история, форматы, лучшие треки
 */
export const getProfileStats = (profileId) => {
    return api.get(`/duels/stats/profile/${profileId}`).then((res) => res.data);
};

/**
 * Получить историю дуэлей игрока
 * @param {string} profileId - ID профиля
 * @param {number} [limit=20] - Количество записей (макс. 100)
 * @returns {Promise<Array>} История дуэлей
 */
export const getDuelHistory = (profileId, limit = 20) => {
    return api.get(`/duels/stats/history/${profileId}`, { params: { limit } }).then((res) => res.data);
};

/**
 * Получить данные для графика изменения рейтинга
 * @param {string} profileId - ID профиля
 * @param {number} [days=30] - Период в днях (макс. 365)
 * @returns {Promise<Array>} Данные для графика
 */
export const getRatingGraph = (profileId, days = 30) => {
    return api.get(`/duels/stats/rating-graph/${profileId}`, { params: { days } }).then((res) => res.data);
};

/**
 * Получить статистику по форматам (SOLO, 2v2, 3v3)
 * @param {string} profileId - ID профиля
 * @returns {Promise<Array>} Статистика по форматам
 */
export const getFormatStats = (profileId) => {
    return api.get(`/duels/stats/formats/${profileId}`).then((res) => res.data);
};

/**
 * Получить лучшие треки игрока
 * @param {string} profileId - ID профиля
 * @param {number} [limit=5] - Количество треков (макс. 20)
 * @returns {Promise<Array>} Лучшие треки
 */
export const getBestTracks = (profileId, limit = 5) => {
    return api.get(`/duels/stats/best-tracks/${profileId}`, { params: { limit } }).then((res) => res.data);
};

/**
 * Получить недавнюю форму игрока (последние результаты)
 * @param {string} profileId - ID профиля
 * @param {number} [limit=5] - Количество игр (макс. 20)
 * @returns {Promise<Array>} Результаты: W (победа), L (поражение), D (ничья)
 */
export const getRecentForm = (profileId, limit = 5) => {
    return api.get(`/duels/stats/recent-form/${profileId}`, { params: { limit } }).then((res) => res.data);
};

export default {
    getProfileStats,
    getDuelHistory,
    getRatingGraph,
    getFormatStats,
    getBestTracks,
    getRecentForm
};
